import { displayNameFromPath } from '../mediaViewer/mediaFileTypes';
import { FilePreviewPopupShell } from '../mediaViewer/FilePreviewPopupShell';
import type { DocumentEditorKind } from './documentFileTypes';
import { DocumentEditorShell } from './DocumentEditorShell';
import { SpreadsheetEditorShell } from '../spreadsheetEditor/SpreadsheetEditorShell';
import '../mediaViewer/MediaPreviewPopup.css';
import './DocumentPreviewPopup.css';

export interface DocumentPreviewState {
  open: boolean;
  kind: DocumentEditorKind;
  mountId: string;
  relativePath: string;
}

interface DocumentPreviewPopupProps {
  state: DocumentPreviewState | null;
  onClose: () => void;
}

export function DocumentPreviewPopup({ state, onClose }: DocumentPreviewPopupProps) {
  const open = state?.open ?? false;
  const kind = state?.kind ?? 'richedit';
  const mountId = state?.mountId ?? '';
  const relativePath = state?.relativePath ?? '';

  const fileName = displayNameFromPath(relativePath);
  const title = fileName ? `Document preview: ${fileName}` : 'Document preview';

  return (
    <FilePreviewPopupShell visible={open} title={title} onClose={onClose}>
      <div className="document-preview-popup__body">
        {open && mountId && relativePath ? (
          kind === 'spreadsheet' ? (
            <SpreadsheetEditorShell
              mode="preview"
              mountId={mountId}
              path={relativePath}
              title={fileName}
              embeddedInPopup
            />
          ) : (
            <DocumentEditorShell
              mode="preview"
              mountId={mountId}
              path={relativePath}
              title={fileName}
              embeddedInPopup
            />
          )
        ) : null}
      </div>
    </FilePreviewPopupShell>
  );
}
